<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import { slide } from 'svelte/transition'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import IconifyIcon from '@iconify/svelte'
    import exchangeIcon from '@iconify/icons-fa-solid/exchange-alt'
    import downIcon from '@iconify/icons-fa-solid/arrow-down'
    import {clickOutside} from 'src/components/#common/helpers/clickOutside'
    import arrow from './arrow.svg'
    import { onMount, onDestroy } from 'svelte'
    import Time from 'svelte-time'
    import {myBalance} from 'src/components/cabinet/#services/myBalance'
    import {roundNumber, roundNumberToCeil, roundNumberToFloor} from 'src/components/#common/helpers/helpers'
    import {ligamentsList, swap, swapHistory} from 'src/components/cabinet/#services/cryptoMarket'
    import {showAlert} from 'src/components/#common/alert/store'

    let fee
    let rate
    let error
    let interval
    let minAmount
    let allTokens
    let firstPool
    let secondPool
    let firstAmount
    let secondAmount
    let allLigaments
    let loading = true
    let selectedLigament
    let availableLigaments
    let selectedSecondToken
    let swapSending = false
    let firstTokenDropdown = false
    let selectedFirstToken = 'WLIS'
    let secondTokenDropdown = false
    let confirmSwapModalOpen = false

    let currentPage = 0
    let perPage = 15

    ligamentsList.reset()
    ligamentsList.send()
    swapHistory.send({ data: { page: currentPage + 1, perPage }})

    $:currentPage,perPage,swapHistory.send({ data: { page: currentPage + 1, perPage }})

    async function autoUpdate() {
        try {
            clearInterval(interval)
            ligamentsList.reset()
            allTokens = undefined
            await ligamentsList.request()
            await calculateSecondAmount()
        } catch (err) {
            console.error(err)
        } finally {
            interval = setInterval(autoUpdate, 15000)
        }
    }

    $: if (!allTokens && $ligamentsList?.hasValue && $myBalance.hasValue) {
        allLigaments = $ligamentsList?.value

        allLigaments = (
            +$myBalance.value.data?.LIS > 0 ||
            +$myBalance.value.data?.PLIS > 0 ||
            +$myBalance.value.data?.WLIS > 0 ||
            +$myBalance.value.data?.PWLIS > 0
        ) ? allLigaments :
            allLigaments.filter(pair => pair.firstToken !== "WLIS" && pair.secondToken !== "WLIS")

        allTokens = getUniqueTokens(allLigaments)
        allTokens = allTokens.filter(t => t !== 'USDT')
        availableLigaments = getAvailableLigaments(selectedFirstToken)
        if (!selectedSecondToken && availableLigaments) {
            selectedSecondToken = availableLigaments[0]
        }
        getLigament()
    }

    function getLigament() {
        if (selectedFirstToken && selectedSecondToken) {
            selectedLigament = allLigaments.find(obj =>
                (obj.firstToken === selectedFirstToken && obj?.secondToken === selectedSecondToken) ||
                (obj.firstToken === selectedSecondToken && obj?.secondToken === selectedFirstToken)
            )
            getFeeAndPool()
        }
    }

    function getFeeAndPool() {
        if  (selectedLigament) {
            if (selectedLigament?.firstToken === selectedFirstToken) {
                fee = +selectedLigament?.secondFee
                firstPool = +selectedLigament?.firstPool
                secondPool = +selectedLigament?.secondPool
                minAmount = +selectedLigament?.minFirstAmount

            } else if (selectedLigament?.secondToken === selectedFirstToken) {
                fee = +selectedLigament?.firstFee
                firstPool = +selectedLigament?.secondPool
                secondPool = +selectedLigament?.firstPool
                minAmount = +selectedLigament?.minSecondAmount
            }
        }
    }

    function calculateSecondAmount() {
        if (firstAmount && firstAmount > 0 && fee && firstPool && secondPool) {
            secondAmount = calculateResultAmount(firstAmount, fee, firstPool, secondPool)
            rate = roundNumberToFloor(secondAmount / firstAmount)
        } else {
            secondAmount = ''
            rate = ''
        }
    }

    function calculateResultAmount(amount, fee, firstPool, secondPool) {
        let prepareResultSum = (amount + firstPool) / amount
        let resultSumWithoutFee = secondPool / prepareResultSum
        let companyFee = resultSumWithoutFee / 100 * fee
        return roundNumberToFloor(resultSumWithoutFee - companyFee)
    }

    function calculateFirstAmount() {
        if (secondAmount && secondAmount > 0 && fee && firstPool && secondPool) {
            firstAmount = roundNumberToCeil(-secondAmount * firstPool / ((secondAmount - secondPool) * (1 - fee/100)))
            firstAmount = firstAmount > 0 ? firstAmount : ''
            if (firstAmount) {
                rate = roundNumberToFloor(secondAmount / firstAmount)
            } else {
                rate = ''
            }
        } else {
            firstAmount = ''
            rate = ''
        }
    }

    function getUniqueTokens(array) {
        let uniqueValues = {}

        array.forEach((obj) => {
            uniqueValues[obj?.firstToken] = true
            uniqueValues[obj?.secondToken] = true
        })

        return Object.keys(uniqueValues)
    }

    function selectFirstToken(token) {
        selectedFirstToken = token
        firstTokenDropdown = false
        availableLigaments = getAvailableLigaments(token)
        if (availableLigaments) {
            selectedSecondToken = availableLigaments[0]
            getLigament()
        }
        calculateSecondAmount()
    }

    function selectSecondToken(token) {
        selectedSecondToken = token
        secondTokenDropdown = false
        getLigament()
        getFeeAndPool()
        calculateSecondAmount()
    }

    function swapTokens() {
        let checkAvailableLigaments = getAvailableLigaments(selectedSecondToken)
        if (!checkAvailableLigaments.find(e => e === selectedFirstToken)) return

        if (selectedSecondToken === 'USDT') return

        if (firstAmount === roundNumber(+$myBalance.value.data[selectedFirstToken])) {
            firstAmount = roundNumber(+$myBalance.value.data[selectedSecondToken])
        }
        let firstToken = selectedFirstToken
        selectedFirstToken = selectedSecondToken
        selectedSecondToken = firstToken
        availableLigaments = getAvailableLigaments(selectedFirstToken)
        getFeeAndPool()
        calculateSecondAmount()
    }

    function getAvailableLigaments(token) {
        if (!allLigaments) return []

        let uniqueValues = new Set()

        allLigaments.forEach((obj) => {
            if (obj?.firstToken === token) {
                uniqueValues.add(obj?.secondToken)
            }
            if (obj?.secondToken === token) {
                uniqueValues.add(obj?.firstToken)
            }
        });

        let result = Array.from(uniqueValues)

        // disallow swap to LIS
        result = result.filter(t => t !== 'WLIS')

        if (token === 'USDT') {
            result = result.filter(t => t !== 'WPEPE' && t !== 'WDOGE' && t !== 'Matic' && t !== 'Near')
        }

        return result
    }


    function maxAmount() {
        if ($myBalance.value.data) {
            firstAmount = roundNumber(+$myBalance.value.data[selectedFirstToken])
            calculateSecondAmount()
        }
    }

    async function swapHandler() {
        try {
            swapSending = true

            await swap.request({ data: {
                from: selectedFirstToken,
                to: selectedSecondToken,
                amount: firstAmount.toString()
            }})

            firstAmount = ''
            secondAmount = ''

            showAlert.set({
                status: 'success',
                text: 'Swap successful'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            swapSending = false
            clearInterval(interval)
            ligamentsList.reset()
            allTokens = undefined
            await ligamentsList.request()
            await calculateSecondAmount()
            interval = setInterval(autoUpdate, 15000)
            swapHistory.send({ data: { page: currentPage + 1, perPage }})
            confirmSwapModalOpen = false
        }
    }

    function isHighPriceImpact(firstAmount, firstPool, secondPool) {
        const coefficientFinalPrice = (firstPool+firstAmount)/firstPool

        const ourLisRate = secondPool/firstPool

        let priceImpactPercent = ((((ourLisRate / coefficientFinalPrice) / ourLisRate) - 1) * 100)

        priceImpactPercent = priceImpactPercent < 0 ? priceImpactPercent * -1 : priceImpactPercent

        return Math.floor(priceImpactPercent)
    }

    function replaceTokenName(token) {
        if (token === 'WLIS') {
            return 'LIS'
        } else if (token === 'WDOGE') {
            return 'DOGE'
        } else if (token === 'WPEPE') {
            return 'PEPE'
        } else {
            return token
        }
    }

    onMount(() => {
        interval = setInterval(autoUpdate, 15000)
    })

    onDestroy(() => {
        clearInterval(interval)
    })
</script>

<svelte:head>
    <title>Swap</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper swap-wrapper">
            <div class="page-title">Swap</div>
            <Alert />
            <div class="swap-form">
                <div class="form-group mb-2">
                    <div class="token-wrapper">
                        <input type="number" class="form-control amount-field first" placeholder="0"
                           bind:value={firstAmount} on:input={calculateSecondAmount}>
                        <div class="dropdown" use:clickOutside={() => {firstTokenDropdown = false}}
                             class:active={firstTokenDropdown}>
                            <button class="btn-max-amount notranslate" on:click={maxAmount}
                                disabled={!$myBalance.hasValue || !$myBalance.value.data[selectedFirstToken]}>max
                            </button>
                            <div class="dropdown-selected">
                                <div class="need-select notranslate"
                                    on:click={() => firstTokenDropdown = !firstTokenDropdown}>
                                    <img src="/images/tokens/{selectedFirstToken}.svg" class="coin-icon" alt="">
                                    {replaceTokenName(selectedFirstToken)}
                                    <img src="{arrow}" class="arrow" alt="">
                                </div>
                            </div>
                            <div class="token-balance">
                                {#if !$myBalance.hasValue && $myBalance.loading}
                                    Loading...
                                {:else if $myBalance.hasValue}
                                    <span class="notranslate">Balance:
                                        {roundNumber(+$myBalance.value.data[selectedFirstToken])}
                                        {replaceTokenName(selectedFirstToken)}
                                    </span>
                                {:else if $myBalance.error}
                                    Error
                                {/if}
                            </div>
                            <div class="dropdown-list">
                                {#if !allTokens && $ligamentsList.loading}
                                    Loading...
                                {:else if allTokens}
                                    {#each allTokens as token}
                                        <div class="item notranslate" on:click={() => selectFirstToken(token)}>
                                            <img src="/images/tokens/{token}.svg" class="coin-icon" alt="">
                                            {replaceTokenName(token)}
                                        </div>
                                    {/each}
                                {:else if $ligamentsList.error}
                                    Error
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="change-tokens">
                    <button class="change-btn" on:click={swapTokens} disabled={!$ligamentsList.hasValue || !selectedSecondToken}>
                        <IconifyIcon icon={exchangeIcon} rotate="90deg"/>
                    </button>
                </div>
                <div class="form-group">
                    <div class="token-wrapper">
                        <input type="number" class="form-control amount-field" placeholder="0"
                           bind:value={secondAmount} on:input={calculateFirstAmount}>
                        <div class="dropdown" use:clickOutside={() => secondTokenDropdown = false}
                             class:active={secondTokenDropdown}>
                            <div class="dropdown-selected">
                                <div class="need-select" on:click={() => secondTokenDropdown = !secondTokenDropdown}>
                                    {#if selectedSecondToken}
                                        <img src="/images/tokens/{selectedSecondToken}.svg" class="coin-icon" alt="">
                                        {replaceTokenName(selectedSecondToken)}
                                    {:else if $ligamentsList.loading}
                                        <span class="coin-icon"></span>LOAD
                                    {:else}
                                        <span class="coin-icon"></span>Empty
                                    {/if}
                                    <img src="{arrow}" class="arrow" alt="">
                                </div>
                            </div>
                            <div class="token-balance">
                                {#if !$myBalance.hasValue && $myBalance.loading}
                                    Loading...
                                {:else if $myBalance.hasValue && selectedSecondToken}
                                    <span class="notranslate">Balance:
                                        {roundNumber(+$myBalance.value.data[selectedSecondToken])}
                                        {replaceTokenName(selectedSecondToken)}
                                    </span>
                                {:else if $myBalance.error}
                                    Error
                                {/if}
                            </div>
                            <div class="dropdown-list">
                                {#if !availableLigaments && $ligamentsList.loading}
                                    Loading...
                                {:else if availableLigaments}
                                    {#each availableLigaments as token}
                                        <div class="item notranslate" on:click={() => selectSecondToken(token)}>
                                            <img src="/images/tokens/{token}.svg" class="coin-icon" alt="">
                                            {replaceTokenName(token)}
                                        </div>
                                    {/each}
                                {:else if $ligamentsList.error}
                                    Error
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-0">
                    {#if rate}
                        <div transition:slide={{duration: 350}}>
                            <div class="swap-info pb-3">
                                <div class="notranslate">
                                    1 {replaceTokenName(selectedFirstToken)}
                                    = {rate} {replaceTokenName(selectedSecondToken)}
                                </div>
                            </div>
                        </div>
                    {/if}
                    {#if minAmount && firstAmount && firstAmount < minAmount}
                        <div transition:slide={{duration: 350}}>
                            <div class="invalid-feedback d-block">
                                Min amount: {minAmount} {replaceTokenName(selectedFirstToken)}
                            </div>
                        </div>
                    {/if}
                    {#if firstAmount && firstPool && secondPool && isHighPriceImpact(firstAmount, firstPool, secondPool) >= 50}
                        <div transition:slide={{duration: 350}}>
                            <div class="invalid-feedback d-block">
                                Price impact is very high ({isHighPriceImpact(firstAmount, firstPool, secondPool)}%)
                            </div>
                        </div>
                    {/if}
                </div>
                <button class="btn active-btn w-100" on:click={() => {confirmSwapModalOpen = true; calculateSecondAmount()}}
                    class:loading={swapSending} disabled={!firstAmount || !minAmount || swapSending || minAmount > firstAmount
                    || ($myBalance.hasValue && firstAmount > +$myBalance.value.data[selectedFirstToken])
                    || !secondPool || !firstPool || !secondPool || isHighPriceImpact(firstAmount, firstPool, secondPool) >= 50}>
                    <span>Swap</span>
                </button>
            </div>
            <Modal bind:visible={confirmSwapModalOpen}>
                <svelte:fragment slot="content">
                    <div class="modal-custom__title">Confirm Swap</div>
                    <div class="modal-custom__text text-center">
                        Are you sure you want to confirm the exchange?
                        <div class="preview-swap">
                            <div class="need-select notranslate">
                                <img src="/images/tokens/{selectedFirstToken}.svg" class="coin-icon" alt="">
                                {firstAmount ? firstAmount : 'Loading...'}
                                {replaceTokenName(selectedFirstToken)}
                            </div>
                            <div class="icon">
                                <IconifyIcon icon={downIcon}/>
                            </div>
                            <div class="need-select notranslate">
                                <img src="/images/tokens/{selectedSecondToken}.svg" class="coin-icon" alt="">
                                {secondAmount ? secondAmount : 'Loading...'}
                                {replaceTokenName(selectedSecondToken)}
                            </div>
                        </div>
                        <div class="note">*The exchange rate may vary slightly, because another user's exchange may be
                            in progress right now</div>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { confirmSwapModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" on:click={swapHandler} class:loading={swapSending}
                            disabled={!firstAmount || !minAmount || swapSending || minAmount > firstAmount
                            || ($myBalance.hasValue && firstAmount > +$myBalance.value.data[selectedFirstToken])}>
                            <span>Confirm</span>
                        </button>
                    </div>
                </svelte:fragment>
            </Modal>
            {#if !$swapHistory.hasValue && $swapHistory.loading}
                <div class="my-transactions-table text-center">Loading...</div>
            {:else if !$swapHistory.hasValue && $swapHistory.error }
                <div class="my-transactions-table text-center">Something went wrong. Try refreshing the page.</div>
            {:else if $swapHistory.hasValue && $swapHistory.value.totalCount > 0}
                <div class="my-transactions-table swap-list" style="--Arrow:url({arrow});">
                    <div class="transactions-table-header">
                        <div>From</div>
                        <div>To</div>
                        <div>Date</div>
                    </div>
                    <div class="transactions-table-body">
                        {#each $swapHistory.value.data as { fromToken, toToken, credit, debit, createdAt }}
                            <div class="transactions-table-row">
                                <div class="notranslate">
                                    <img src="/images/tokens/{fromToken}.svg" class="coin-icon" alt="">
                                    {credit} {replaceTokenName(fromToken)}
                                </div>
                                <div class="notranslate">
                                    <img src="/images/tokens/{toToken}.svg" class="coin-icon" alt="">
                                    {debit} {replaceTokenName(toToken)}
                                </div>
                                <div>
                                    <Time live relative timestamp={createdAt}/>
                                </div>
                            </div>
                        {/each}
                    </div>
                    <Pagination bind:currentPage={currentPage} totalCount={$swapHistory.value.totalCount} {perPage}/>
                </div>
            {/if}
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .token-wrapper {
        display: flex;
        position: relative;
        border-radius: 12px;
        background: #050e23;
    }

    .change-tokens {
        width: 100%;
        position: relative;
        display: flex;
        justify-content: center;
    }

    .change-btn {
        background: #343168;
        border: 2px solid #494591;
        color: white;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        position: absolute;
        left: 50%;
        margin: -24px 0 0 -20px;
        text-align: center;
        padding: 0 0 4px;
        z-index: 2;
        transition: .2s;
    }

    .change-btn:hover {
        background: #7262FF;
        border-color: #7262FF;
    }

    .change-btn[disabled],
    .change-btn[disabled]:hover {
        background: #272c33;
    }

    .swap-form {
        max-width: 500px;
        margin: 40px auto 20px;
    }

    .swap-form .form-control {
        border: 2px solid #494591;
        font-size: 26px;
        color: white;
        line-height: 50px;
        transition: .25s;
    }

    .swap-form .form-control:focus {
        border-color: #7262FF;
    }

    .invalid-feedback {
        font-size: 14px;
        margin: -5px 0 0 0 !important;
        padding: 0 0 1rem 0 !important;
        display: block;
    }

    .token-balance {
        font-size: 13px;
        color: #9592CD;
        margin-block: 5px;
        position: absolute;
        bottom: 4px;
        right: 12px;
        white-space: nowrap;
    }

    .form-group label {
        font-size: 15px;
        margin-bottom: 5px;
    }

    .form-control:focus {
        box-shadow: none;
    }

    .coin-icon {
        height: 24px;
        width: 24px;
        margin: 0 6px 0 0;
        vertical-align: top;
        background: white;
        border-radius: 50%;
        padding: 3px;
        object-fit: contain;
        object-position: center;
    }

    .form-group {
        margin-bottom: 18px;
    }

    .swap-info {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: lightgrey;
    }

    :global(.swap-list .pagination) {
        justify-content: center;
    }

    .dropdown {
        border-radius: 6px;
        position: initial;
        z-index: 4;
    }
    .dropdown.active {
        z-index: 5;
    }

    .dropdown.disabled .dropdown-selected {
        cursor: default;
    }

    .dropdown-selected {
        padding: 0;
        font-size: 18px;
        color: white;
        font-weight: 500;
        border: 2px solid #494591;
        border-left: 0;
        height: 80px;
        border-radius: 0 12px 12px 0;
        position: relative;
        user-select: none;
        transition: .25s;
    }

    .arrow {
        position: absolute;
        transform: rotate(180deg);
        right: 7px;
        top: 50%;
        margin-top: -10px;
        transition: .15s;
    }

    .preview-swap {
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 10px 0;
    }

    .preview-swap .need-select {
        padding: 4px 12px 4px 4px;
        background: #424a60;
        margin: 6px auto;
        display: flex;
        align-items: center;
        cursor: default;
    }

    .preview-swap .icon {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .dropdown.active .arrow {
        transform: rotate(0deg);
    }

    .need-select {
        padding: 4px 38px 4px 4px;
        height: 32px;
        margin: 10px;
        border-radius: 32px;
        background: #343168;
        white-space: nowrap;
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: .15s;
    }

    .need-select:hover {
        background: #494591;
    }

    .dropdown-list {
        display: none;
        padding: 5px 15px;
        position: absolute;
        background: #1c1a3f;
        border-radius: 12px 0 12px 12px;
        border: 2px solid #494591;
        right: 0;
        z-index: 2;
        top: 53px;
        min-width: 140px;
    }

    .dropdown.active .dropdown-list {
        display: block;
    }

    .dropdown-list .item {
        font-size: 16px;
        color: white;
        padding: 12px 0;
        cursor: pointer;
        user-select: none;
        align-items: center;
        display: flex;
        transition: .25s;
    }

    .dropdown-list .item:not(:last-child) {
        border-bottom: 1px solid #343168;
    }

    .dropdown-list .item:hover {
        color: #cbcaca;
    }

    .dropdown-list .item:last-child {
        margin-bottom: 0;
    }

    .transactions-table-header {
        display: flex;
        width: 100%;
        max-width: 900px;
        margin: 0 auto 15px;
    }

    .transactions-table-body {
        max-width: 900px;
        margin: 0 auto;
    }

    .transactions-table-header > div {
        width: 33.33%;
        padding: 15px 50px;
        background: #CAD5E0;
        color: #272C33;
        font-size: 18px;
        line-height: 20px;
        font-weight: 500;
    }

    .transactions-table-header > div:first-child {
        border-radius: 8px 0 0 8px;
    }

    .transactions-table-header > div:last-child {
        border-radius: 0 8px 8px 0;
    }

    .transactions-table-row {
        border: 1px solid #CAD5E0;
        border-radius: 8px;
        display: flex;
        width: 100%;
        margin-bottom: 10px;
    }

    .transactions-table-row > div {
        width: 33.33%;
        padding: 15px 50px;
        font-size: 20px;
        line-height: 20px;
        font-weight: 500;
        display: flex;
        align-items: center;
        white-space: nowrap;
        position: relative;
    }

    .my-transactions-table {
        margin: 60px auto 0;
        max-width: 1174px;
    }

    .mr-25 {
        margin-right: 25px;
    }

    .resend-confirmation span {
        color: #7262FF;
        cursor: pointer;
    }

    .form-control.amount-field {
        border-radius: 12px 0 0 12px;
        border-right: 0;
    }

    .form-control.amount-field.first {
        padding-right: 68px;
    }

    .form-control.amount-field:focus + .dropdown .dropdown-selected {
        border-color: #7262FF;
    }

    .btn-max-amount {
        position: absolute;
        margin: 12px 0 0 -54px;
        background: #343168;
        border: 0;
        border-radius: 32px;
        padding: 5px 12px;
        color: rgba(255, 255, 255, 0.85);
        font-size: 15px;
        box-shadow: none;
        line-height: 22px;
        transition: .25s;
    }

    .btn-max-amount[disabled] {
        opacity: 0.8;
    }

    .btn-max-amount:hover {
        background: #7262FF;
    }

    .note {
        font-size: 13px;
        color: #9799a3;
        font-style: italic;
        text-align: center;
        max-width: 360px;
        margin: 0 auto;
    }

    @media(max-width: 1199px) {
        .transactions-table-row > div,
        .transactions-table-header > div {
            padding: 15px 20px;
            font-size: 16px;
        }
    }

    @media(max-width: 767px) {
        .swap-form {
            margin: 20px auto;
        }

        .change-btn {
            left: 45px;
            border-radius: 50%;
        }

        .swap-form .form-control {
            font-size: 22px;
        }

        .dropdown-selected {
            font-size: 16px;
        }

        .transactions-table-header {
            display: none;
        }

        .transactions-table-row {
            flex-wrap: wrap;
            padding: 5px 0;
            margin-bottom: 15px;
            position: relative;
        }

        .transactions-table-row > div {
            width: 100%;
            position: relative;
            padding: 3px 10px;
        }

        .transactions-table-row .coin-icon {
            height: 20px;
            width: 20px;
        }

        .transactions-table-row > div:nth-child(1) {
            padding-bottom: 15px;
            position: relative;
        }

        .transactions-table-row > div:nth-child(1):after {
            content: "";
            position: absolute;
            background: var(--Arrow) no-repeat center;
            left: 10px;
            bottom: -3px;
            width: 20px;
            height: 20px;
            transform: rotate(180deg);
            opacity: 0.7;
        }

        .transactions-table-row > div:nth-child(3) {
            width: 100%;
            position: absolute;
            top: 50%;
            right: 0;
            justify-content: flex-end;
            font-size: 14px;
            margin-top: -14px;
        }

        .label {
            padding-right: 5px;
        }

        .my-transactions-table {
            margin: 40px auto 0;
        }
    }
</style>
